import { jsx as T } from "react/jsx-runtime";
import { useRef as S, useState as x, useEffect as P } from "react";
import I from "./roche-scale-on-scroll.module.scss.js";
const M = 1864, W = (i) => (Math.min(window.innerWidth, M) - i) / i, C = (i) => {
  const t = i.getAttribute("data-ratio");
  if (!t) return null;
  const [l, u] = t.split(":").map(parseFloat);
  return l && u ? [l, u] : null;
}, B = ({ children: i }) => {
  const t = S(null), [l, u] = x(1), [R, h] = x("auto"), o = S(null);
  return P(() => {
    const n = t.current;
    if (!n)
      return;
    const s = () => {
      const e = n.querySelector(".image");
      if (!e) {
        o.current = null, h("auto");
        return;
      }
      const w = n.getBoundingClientRect().top + window.scrollY, m = n.getBoundingClientRect().width, d = W(m), r = n.getBoundingClientRect().width, c = C(e), g = c ? Math.floor(r * c[1] / c[0]) : 0;
      o.current = {
        initialSpaceToViewTop: w,
        initialHeight: g,
        widthPercentage: d
      };
      const p = g * (1 + d);
      h(`${p}px`);
    }, a = () => {
      s();
    };
    return window.addEventListener("resize", a), s(), () => {
      window.removeEventListener("resize", a);
    };
  }, []), P(() => {
    const n = t.current;
    if (!n || !o.current) return;
    const s = () => {
      const a = n.getBoundingClientRect().top, e = window.innerHeight;
      if (!(a > e || a < -0.3 * e) && o.current) {
        const { initialSpaceToViewTop: m, widthPercentage: d } = o.current, r = Math.min(m, e), c = e > m, g = c ? 1 : 0.75, f = r * (c ? 0.1 : 0.25), v = r * (1 - g), A = r - f - v, E = Math.min(
          Math.max((r - a - f) / A, 0),
          1
        ), H = 1 + d * E;
        u(H);
      }
    };
    return window.addEventListener("scroll", s, { passive: !0 }), () => {
      window.removeEventListener("scroll", s);
    };
  }, [t.current, o.current]), /* @__PURE__ */ T(
    "div",
    {
      ref: t,
      className: I["scale-on-scroll"],
      style: {
        "--scale-factor": l,
        height: R
      },
      children: i
    }
  );
};
export {
  B as RocheUIScaleOnScroll
};
